import * as ngrxRouterStore from '@ngrx/router-store'

import { State } from './state'

/**
 * Applies the {@link ngrxRouterStore.routerReducer}, as well as some of our own
 * logic
 */
export const reducer: typeof ngrxRouterStore.routerReducer<
  State.Payload,
  State
> = (state, action) => {
  // NOTE: This reducer seems to either return the state as-is, or create a new
  // state object that only contains the standard ngrx router properties, non of
  // the extra properties that we extra added
  const reducedState = ngrxRouterStore.routerReducer(state, action)

  // We are trying to return early here if there is nothing we need to do with
  // the state
  if (
    // we can only skip the below logic if the state is the same because
    // otherwise, as mentioned above, the state might be missing properties,
    // that we need to add back
    reducedState === state &&
    // if the action is any of below types, we need to update the count of
    // openRequests
    ![
      ngrxRouterStore.ROUTER_NAVIGATED,
      ngrxRouterStore.ROUTER_CANCEL,
      ngrxRouterStore.ROUTER_ERROR,
      ngrxRouterStore.ROUTER_REQUEST,
    ].includes(action.type)
  ) {
    // If there is nothing we need to do to the state, then we can return the
    // existing state
    return state
  }

  const newState = {
    // NOTE: since we cannot include the initial state at the beginning (as that
    // interferes with NgRx router store's initialization logic), we add it only
    // after their reducer has done something to the state (presumably at that
    // point, the initialization logic is done)
    ...State.INITIAL,
    // NOTE: when reducedState !== state, it is usually a new object that is
    // missing the properties we've added to the state. This adds them back
    ...state,
    ...reducedState,
  }

  if (action.type === ngrxRouterStore.ROUTER_REQUEST) {
    // If this is a request, we have one additional open request
    newState.openRequests++
  } else if (
    [
      ngrxRouterStore.ROUTER_NAVIGATED,
      ngrxRouterStore.ROUTER_CANCEL,
      ngrxRouterStore.ROUTER_ERROR,
    ].includes(action.type)
  ) {
    // If this is a success, cancellation, or error, we have one fewer open
    // requests
    newState.openRequests--
  }

  return newState
}
